import React, { Component } from 'react';


export class ProgramasListItem extends Component {
    constructor(props) {
        super(props);
        this.state = { programas: [], idPrograma: 0, listaMetodologias: [], listaEspecificaciones: [], listaMetadatos: [] };
        this.onClick = this.onClick.bind(this);
    }

    onClick() {
        const { programaClicked, idPrograma, nombre } = this.props;
        programaClicked(idPrograma, nombre);
    }

    render() {
        const { nombre } = this.props;
        return (
            
                <span onClick={this.onClick}>{nombre}</span>
            
        );
    }
}
